/* MED-TAC Hero CTA Patch — replaces bundle-builder links & adds quiz CTA */
(function(){
  'use strict';

  /* === 1. Replace all /pages/bundle-builder/911 links site-wide === */
  var OLD_URL = '/pages/bundle-builder/911';
  var NEW_URL = '/pages/build-your-own-ifak';
  
  document.querySelectorAll('a[href*="bundle-builder/911"]').forEach(function(a) {
    a.href = a.href.replace(/\/pages\/bundle-builder\/911/g, NEW_URL);
  });

  /* === 2. Add quiz CTA to hero section === */
  var ctaContainer = document.querySelector('.fudge-hero-1__ctas');
  if (ctaContainer && !document.getElementById('medtac-quiz-cta')) {
    /* Only add if there's exactly one CTA (the primary) */
    var existing = ctaContainer.querySelectorAll('.fudge-hero-1__cta');
    if (existing.length === 1) {
      var quizBtn = document.createElement('a');
      quizBtn.id = 'medtac-quiz-cta';
      quizBtn.className = 'fudge-hero-1__cta fudge-hero-1__cta--secondary';
      quizBtn.href = '#shopify-section-fudge-JDjDi-trauma-kit-quiz';
      quizBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-right:8px;"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> FIND MY KIT \u2014 TAKE THE QUIZ';
      quizBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var quizEl = document.getElementById('shopify-section-fudge-JDjDi-trauma-kit-quiz');
        if (quizEl) {
          quizEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      ctaContainer.appendChild(quizBtn);
    }

    /* Also add grid icon to the primary button if it doesn't have one */
    var primaryBtn = ctaContainer.querySelector('.fudge-hero-1__cta--primary');
    if (primaryBtn && !primaryBtn.querySelector('svg')) {
      var gridSvg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-right:8px;"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>';
      primaryBtn.insertAdjacentHTML('afterbegin', gridSvg);
    }
  }
})();
